export var getLessonStatisticData = function (state) { return state.lessonStatistic.data; };
export var getLessonStatisticFilter = function (state) { return state.lessonStatistic.filter; };
